import { CheckpointTypeFilterType } from '@/entities/checkpoint';
import { TCheckPointSchema } from '@/schemas/check-point/check-point.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { mapCheckpointTypeFilterAPI } from '@/utils/map.utils';

const CHECK_POINT_URI = '/checkPoint';

export const createNewCheckPoint = async (checkPoint: TCheckPointSchema) => {
  return requestApi({
    url: CHECK_POINT_URI,
    method: HTTP_METHOD.POST,
    body: checkPoint,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingCheckPoint = async (query?: TCheckPointSchema) => {
  let url = `${CHECK_POINT_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.name) {
    params.append('name', query.name);
  }

  if (query?.type) {
    params.append('type', query.type);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const duplicateCheckPoint = async (id: string, languageCode: string) => {
  return requestApi({
    url: `${CHECK_POINT_URI}/duplicate/${id}/${languageCode}`,
    method: HTTP_METHOD.POST,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllCheckPoints = async () => {
  return requestApi({
    url: `${CHECK_POINT_URI}/allCheckPoints`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllCheckPoints = async (
  filter: CheckpointTypeFilterType,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc'
) => {
  const filterMapped = mapCheckpointTypeFilterAPI(filter);

  let url = `${CHECK_POINT_URI}/all?${filterMapped}&page=${page}&limit=${limit}`;

  if (sortBy) {
    url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
  }

  return requestApi({
    url: url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveCheckPoints = async () => {
  return requestApi({
    url: `${CHECK_POINT_URI}/totalActive`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getCheckPointById = async (id: string) => {
  return requestApi({
    url: `${CHECK_POINT_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllCheckPointsByGroupId = async (id: string) => {
  return requestApi({
    url: `${CHECK_POINT_URI}/group/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const uploadCheckPointVideo = async (formData: FormData) => {
  return requestApi({
    url: `${CHECK_POINT_URI}/uploadVideoFile`,
    method: HTTP_METHOD.POST,
    body: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateCheckPoint = async (checkPoint: TCheckPointSchema) => {
  return requestApi({
    url: `${CHECK_POINT_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: checkPoint,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyCheckPoints = async (
  checkPoints: TCheckPointSchema[]
) => {
  return requestApi({
    url: `${CHECK_POINT_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: checkPoints,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
